<div class="center" >
    <app-empty-state [data]="emptyStateLogs" />
</div>